import { Effect } from 'effect';

import { requestPasswordReset } from '../../../request/backendApi/customer/resetPasswordForCustomer';
import { RuntimeClientAtom } from '../../../runtime/RuntimeClient';
import type { CustomerResetPasswordPayload } from '@vs-shop/schemas/customer';

export const resetPasswordCustomerAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (data: CustomerResetPasswordPayload) {
    return yield* requestPasswordReset(data);
  })
);
